module.exports = __webpack_public_path__ + "static/media/Radio.58faeb96.svg";